import { createBrowserRouter, RouteObject, RouterProvider } from 'react-router';
import { SUPPORTED_LANGUAGES, TFunction, useTranslation } from 'util/i18next';
import { ErrorPage } from 'components/general/ErrorPage';
import { useMemo } from 'react';
import StandaloneFrame from 'standalone-frame/StandaloneFrame';
import RedirectToAgentProfilePage from 'pages/RedirectToAgentProfilePage';

export function createProfileRoutes(t: TFunction<['user']>): RouteObject[] {
  return [
    {
      element: <StandaloneFrame />,
      errorElement: (
        <ErrorPage
          title={t('user:error.unknownError.title')}
          message={t('user:error.unknownError.message')}
          buttonText={t('user:error.unknownError.button')}
          onClick={() => location.reload()}
        />
      ),
      children: createLocaleRoutes([
        {
          path: ':shopId',
          children: [
            {
              path: 'profile',
              children: [
                {
                  path: 'my-profile',
                  element: <RedirectToAgentProfilePage />,
                },
                {
                  path: 'lipa',
                  lazy: () => import('pages/lipa/LipaProfilePage'),
                },
                {
                  path: 'agent/:agentId',
                  lazy: () => import('pages/agent/AgentProfilePage'),
                },
              ],
            },
            {
              path: 'user/shop/profile',
              lazy: () => import('pages/shop/ShopProfilePage'),
            },
            {
              path: 'user/shop/profile/property-lounge/:propertyLoungeId',
              lazy: () => import('pages/shop/ShopProfilePage'),
            },
          ],
        },
      ]),
    },
  ];
}

function useRouter() {
  const { t } = useTranslation(['user']);
  return useMemo(() => createBrowserRouter(createProfileRoutes(t)), [t]);
}

export function createLocaleRoutes(routes: RouteObject[]): RouteObject[] {
  return [
    ...SUPPORTED_LANGUAGES.map((lang) => ({
      path: lang,
      children: routes,
    })),
    ...routes,
  ];
}

export function ProfileRouter() {
  const router = useRouter();
  return <RouterProvider router={router} />;
}
